import { v4 as uuidv4 } from "uuid";

// Generate a unique id we can use to correlate API requests and errors in Sentry
export const CORRELATION_ID = uuidv4();
